module.exports = __webpack_public_path__ + "static/img/sre-banner.7eefa1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sre-banner.png
// module id = KWJ9
// module chunks = 0